import React from 'react';
import Button from '@mui/material/Button';
import { useGoogleLogin } from '@react-oauth/google';
import { AiOutlineGoogle } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';
import { googleLogin, googleobj, googleregister } from '../actions/index';
import { CustomTooltip } from './Settings/Organization';
import { CONFIG_APP_GOOGLE_LOGIN_CLIENT } from '../configApp';
import * as Sentry from "@sentry/react";
import CryptoJS from 'crypto-js';
import axios from 'axios';

function GoogleLoginButton(props) {
  const history = useHistory();
  const [isLoad, setIsLoad] = React.useState(false);

  const encodeAes = (plainText) => {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY);
    const encryptedData = CryptoJS.AES.encrypt(plainText, key, {
      iv: key,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encryptedData.ciphertext.toString();
  };

  const fetchLocationAndRegister = async (access_token, userInfo) => {
    try {
      // Get user's IP address and location info
      const ipRes = await axios.get("https://api.ipify.org?format=json");
      const locRes = await axios.get(`https://ipapi.co/${ipRes.data.ip}/json/`);

      const location = `${locRes.data.city}, ${locRes.data.country_name}`;
      const phoneNumber = locRes.data.country_calling_code;

      // Create companyName if not present
      const email = userInfo.email;
      const username = email?.split('@')[0]?.replace(/\./g, '-');
      const randomString = Array.from({ length: 4 }, () =>
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'[
          Math.floor(Math.random() * 62)
        ]
      ).join('');
      const companyName = `${username}-${randomString}`;

      // Compose registration payload
      const registrationData = {
        sessionId: "google-oauth-session",
        email,
        password: encodeAes(access_token),
        companyName,
        phoneNumber,
        industry: "Undefined",
        location,
        firstName: userInfo.given_name,
        lastName: userInfo.family_name,
        ssoType: "google"
      };

      console.log("[📝 Registering user with data]:", registrationData);

      // Trigger registration redux action
      props.googleregister(registrationData, (err) => {
        if (err) {
          console.error("[❌ Registration failed]:", err);
        } else {
          console.log("[✅ Registration successful]");
        }
      });
    } catch (error) {
      console.error("[❌ Error during location fetch or registration]:", error);
    }
  };

  const login = useGoogleLogin({
    flow: 'implicit',
    scope: 'openid profile email',
    onSuccess: async (tokenResponse) => {
      console.log("[✅ onSuccess] Token Response:", tokenResponse);
      setIsLoad(true);

      try {
        if (!tokenResponse?.access_token) {
          console.error("[❌ Error] access_token is missing from response.");
          return;
        }

        const encryptedToken = encodeAes(tokenResponse.access_token);

        // Store token and user
        props.googleLogin(
          {
            accessToken: encryptedToken,
            ssoType: 'google'
          },
          (result) => {
            console.log("[📦 Redux callback result]:", result);

            if (result === 'Register') {
              // Fetch user info manually
              fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: {
                  Authorization: `Bearer ${tokenResponse.access_token}`
                }
              })
                .then((res) => res.json())
                .then((userInfo) => {
                  props.googleobj(tokenResponse); // Store raw token
                  fetchLocationAndRegister(tokenResponse.access_token, userInfo);

                  // Optionally set Sentry user
                  Sentry.configureScope((scope) => {
                    scope.setUser({ email: userInfo?.email });
                  });
                });
            }
          }
        );
      } catch (err) {
        console.error("[❌ Exception during login flow]:", err);
      } finally {
        setIsLoad(false);
      }
    },
    onError: (err) => {
      console.error("[❌ Google Login Error]:", err);
      setIsLoad(false);
    }
  });

  return (
    <CustomTooltip title={isLoad ? "Loading..." : "Connect With Google"}>
      <Button
        size="large"
        fullWidth
        variant="outlined"
        disableElevation
        disabled={isLoad}
        onClick={() => {
          console.log("[🚀 Triggering Google Login]");
          login();
        }}
        sx={{
          textTransform: "capitalize",
          borderRadius: "24px",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          py: 1
        }}
      >
        {isLoad ? (
          <AiOutlineGoogle style={{ fontSize: "35px" }} />
        ) : (
          <FcGoogle style={{ fontSize: "35px" }} />
        )}
      </Button>
    </CustomTooltip>
  );
}

const mapStateToProps = ({ authReducer }) => ({
  authReducer
});

export default connect(mapStateToProps, { googleLogin, googleobj, googleregister })(GoogleLoginButton);
